<template>
  <section class="items-center">
    <div class="container">
      <vx-card>
        <vx-card v-if="!fUpload" class="items-left mb-base" card-background="#F7F8F9" no-shadow>
          <h2 class="mb-3">Prediction Accuracy:</h2>
          <p class="mb-3">
            GetBoarded helps you board your users in the simplest of manner by
            just dropping their resumes. The AI matches the resumes and parses
            the data in the respective fields.
          </p>
          <!-- <p class="mb-3">Pick our brain!</p>
          <p>
            Upload a resume and let the platform predict your skills,
            personality and other details…
          </p> -->
        </vx-card>
        <div v-if="!fUpload">
          <h3 class="items-left mb-base">Upload Resume</h3>
          <div class="w-full items-center mb-base">
            <upload-file class="btn-upload-file" v-on:uploadedfile="onFileUpload" />
          </div>
        </div>
        <div v-if="fUpload">
          <div>
            <h2 class="items-center flex">
              {{ fName }}
              <feather-icon icon="XIcon" svgClasses="h-16 w-12 mt-4 ml-4 stroke-current"
                class="inline-block vertical-middle align-center cursor-pointer" @click="resetAPI" />
            </h2>
          </div>
          <hr class="mb-base items-center" />
          <div class="items-left">
            <vs-row>
              <div class="mt-8 vs-sm-8 vs-lg-8 p-3">
                <h3 class="mb-base">Generate your api call to parse resume</h3>
              </div>
              <div class="vs-sm-4 vs-lg-4 mt-8">
                <vs-checkbox class="whitespace-no-wrap float-right mt-3 mr-4 items-right"
                  @change="selectAll(json_response_accuracy, $event)" v-model="selectall"></vs-checkbox>
                <h5 class="font-semibold float-right mr-4 items-right">
                  Select All
                </h5>
              </div>
            </vs-row>
            <vs-row>
              <vs-col v-for="(k, v) in json_response_accuracy" :key="k" class="vs-sm-12 vs-lg-4 p-3">
                <div class="parser-item flex items-center px-2 pt-2 pb-0">
                  <div class="mr-1">
                    <div class="con-vs-avatar" style="width: 80px; height: 70px">
                      <div class="con-img vs-avatar--con-img" v-if="
                        json_response_accuracy[v].title === 'Personal Details'
                      ">
                        <img src="../../../../src/assets/images/icons/about.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="json_response_accuracy[v].title === 'Skills'">
                        <img src="../../../../src/assets/images/icons/skills.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="json_response_accuracy[v].title === 'Project'">
                        <img src="../../../../src/assets/images/icons/projects.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="json_response_accuracy[v].title === 'Education'">
                        <img src="../../../../src/assets/images/icons/educational-qualifications.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="json_response_accuracy[v].title === 'Experience'">
                        <img src="../../../../src/assets/images/icons/career-history.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="json_response_accuracy[v].title === 'Languages'">
                        <img src="../../../../src/assets/images/icons/Languages.svg" class="mt-4"
                          style="width: 35px; height: 35px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="
                        json_response_accuracy[v].title === 'Certificates'
                      ">
                        <img src="../../../../src/assets/images/icons/Certificates.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                      <div class="con-img vs-avatar--con-img" v-if="json_response_accuracy[v].title === 'Interests'">
                        <img src="../../../../src/assets/images/icons/Interests.svg" class="mt-4"
                          style="width: 40px; height: 40px" />
                      </div>
                    </div>
                  </div>

                  <div class="
                      w-full
                      flex
                      items-center
                      justify-between
                      overflow-hidden
                    ">
                    <div class="flex flex-col truncate w-5/6 items-left">
                      <h5 class="font-semibold">
                        {{ json_response_accuracy[v].title }}
                      </h5>
                    </div>
                    <div class="flex self-start flex-col mt-2 items-end w-1/6">
                      <span class="whitespace-no-wrap"><vs-checkbox :v-model="json_response_accuracy[v].value"
                          :checked="selectAllStatus" @change="
                            selectOption(json_response_accuracy[v].key, $event)
                            "></vs-checkbox></span>
                    </div>
                  </div>
                </div>
              </vs-col>
              <vs-col class="vs-sm-12 vs-lg-4 p-3">
                <vs-button class="float-right mt-12 get-started-btn" @click.stop="fetchAPI">Fetch Resume
                  Data</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vx-card>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import constants from "@/constants.js";
import UploadFile from "./UploadFile";
import {
  successNotifyService,
  failureNotifyService,
} from "@/services/errors.service.js";

export default {
  name: "Parser",
  data() {
    return {
      json_response_accuracy: [
        {
          title: "Personal Details",
          value: "False",
          src: "@/assets/images/icons/editor-icons/active/${index}.svg",
          key: "personal_details",
        },
        {
          title: "Skills",
          value: "False",
          src: "@/assets/images/icons/editor-icons/active/${index}.svg",
          key: "skills",
        },
        {
          title: "Project",
          value: "False",
          src: "@/assets/images/icons/editor-icons/active/${index}.svg",
          key: "projects",
        },
        {
          title: "Education",
          value: "False",

          key: "educational_details",
        },
        {
          title: "Experience",
          value: "False",
          key: "work_experience",
        },
        {
          title: "Languages",
          value: "False",
          key: "languages",
        },
        {
          title: "Certificates",
          value: "False",
          key: "certificates",
        },
        {
          title: "Interests",
          value: "False",
          key: "interests",
        },
      ],
      fData: new FormData(),
      fPersonalityData: new FormData(),
      fUpload: false,
      selectall: false,
      fName: null,
      selectAllStatus: false,
      finalResponse: {},
    };
  },
  components: { UploadFile },
  computed: {
    json_response() {
      return this.$store.state.parser.json_response;
    },
  },
  methods: {
    openConfirmPopup() {
      this.$store.commit('parser/SET_CONFIRM_SYNC', true)
    },
    getAPIData() {
      if (this.fData.get("file").size <= 5242880) {
        this.finalResponse = {};
        this.$vs.loading();
        axios
          .post(`${constants.parserAPI}`, this.fData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "OAuth": `Bearer 6ae07d16ef072c1f010f8ed46c88837bfe3178e7`
            },
          })
          .then((res) => {
            this.finalResponse = { ...this.finalResponse, ...res.data.response };
            this.$store.commit("parser/SET_JSON_RESPONSE", this.finalResponse);
            this.openConfirmPopup();
            this.$vs.loading.close();
            // this.getPersonality();
          })
          .catch((err) => {
            const payload = {
              currentThis: this,
              text: err,
            };
            failureNotifyService(payload);
            //   throw err;
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } else {
        const payload = {
          currentThis: this,
          title: "File size large",
          text: "File size max 5MB",
        };
        failureNotifyService(payload);
      }
    },
    selectAll(t, event) {
      let v;
      // else{v='False'};
      // this.fData.set(t,v);
      if (this.selectall) {
        if (event.target.checked) {
          v = "True";
        }
        this.selectAllStatus = true;
        for (let i = 0; i <= t.length; i++) {
          console.log("t", t[i].key);
          v = "True";
          this.fData.set(t[i].key, v);
        }
      } else {
        this.selectAllStatus = false;
        for (let i = 0; i <= t.length; i++) {
          console.log("t", t[i].key);
          v = "False";
          this.fData.set(t[i].key, v);
        }
        console.log(
          " this.json_response_accuracy_1",
          this.json_response_accuracy
        );
      }
    },
    getPersonality() {
      this.$vs.loading();
      axios
        .post(`${constants.personalityAPI}`, this.fPersonalityData)
        .then((res) => {
          if (res.data.length) {
            res.data.forEach((item) => {
              this.finalResponse = { ...this.finalResponse, ...item };
              // console.log("your final response is",this.finalResponse);
            });
            this.$store.commit("parser/SET_JSON_RESPONSE", this.finalResponse);
          }
          this.$vs.loading.close();
        })
        .catch(function (error) {
          this.$vs.loading.close();
          throw error;
        });
    },
    onFileUpload(value) {
      this.fName = value.name;
      this.fData.set("file", value);
      this.fPersonalityData.append("file", value);
      this.fUpload = true;
      // this.getAPIData();
    },
    selectOption(t, event) {
      let v;
      if (event.target.checked) {
        v = "True";
      } else {
        v = "False";
      }
      this.fData.set(t, v);
    },
    fetchAPI() {
      this.getAPIData();
    },
    resetAPI() {
      this.resetParserFormData();
      this.finalResponse = {};
      this.fUpload = false;
      this.$store.commit("parser/SET_JSON_RESPONSE");
    },
    resetParserFormData() {
      // this.json_response_accuracy.forEach(element => {
      //   this.fData.set(element.key, element.value)
      // });
      this.fData.set("file", "");
      this.fPersonalityData.set("file", "");
    },
  },
  created() {
    this.json_response_accuracy.forEach((element) => {
      this.fData.append(element.key, element.value);
    });
    this.fData.append("file", "");
  },
};
</script>

<style scoped>
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}

section {
  padding: 0 10rem 2rem 10rem;
  background: #ffffff;
  position: relative;
}

h2 {
  font-style: normal;
  font-weight: 900;
  font-size: 26px;
  line-height: 36px;
  color: #231d4f;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0px 20px;
}

p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: #848199;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0px 20px;
}

h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #231d4f;
}

hr {
  color: #dde6ef;
  opacity: 0.5;
}

.parser-item {
  background: #ffffff;
  border: 1px solid #dde6ef;
  box-sizing: border-box;
  border-radius: 8px;
}

h5 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #848199;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 10px 0px;
}

@media (max-width: 1200px) {
  section {
    padding: 0rem 0rem 2rem 0rem;
  }
}
</style>
